import { Box, Typography } from "@mui/material";
import DivChip from "./DivChip";
import Grid from "@mui/material/Unstable_Grid2";

const AboutUs = () => {
  return (
    <>
      <DivChip text="About Us"></DivChip>
      <Grid>
        <Box component="div" sx={{ mt: 1, mr: 3, ml: 3 }}>
          <Typography
            variant="body1"
            sx={{ fontSize: "1.2rem", textAlign: "center" }}
          >
            Ima ind.G. is a system integrator company since 1998. Our Activity
            is Designing , Implementation, Commissioning of industrial
            Automation projects such as :
            <Typography
              sx={{
                mt: 3,
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
              }}
            >
              <ul style={{ listStyle: "none" }}>
                <li>PLC & PC-Based Automation</li>
                <li>Control, monitoring,Data Logging & Reporting</li>
                <li>Telemetry & SCADA</li>
                <li>Instrument</li>
              </ul>
            </Typography>
          </Typography>
        </Box>
      </Grid>
    </>
  );
};
export default AboutUs;
